<template>
  <router-link :to="{ name: 'memo' }" class="memo-link">
    <img class="memo-icon" :src="memoIcon" alt="" />
    <span>{{ $t('common.memo.creativeMemo') }}</span>
  </router-link>
</template>

<script lang="ts">
import Vue from "vue";
import NoteBookIcon from "@/assets/icons/figma/NoteBook.svg";

export default Vue.extend({
  computed: {
    memoIcon(): string {
      return NoteBookIcon;
    },
  },
});
</script>

<style lang="scss" scoped>
a {
  text-decoration-line: none;
  color: inherit;
}

.memo-link {
  display: flex;
  align-self: center;
  border-radius: var(--radius-rounded);
  border: 2px solid;

  @include mq(pc) {
    padding: 0.5rem 1.5rem;
  }
  @include mq(sp) {
    padding: 0.3rem 1rem;
  }

  & > .memo-icon {
    display: flex;
    align-self: center;
    filter: brightness(0);

    [data-app-theme="dark"] & {
      filter: brightness(0) invert(1);
    }

    @include mq(pc) {
      width: 25px;
      height: auto;
      margin-right: 0.75rem;
    }
    @include mq(sp) {
      width: 20px;
      height: auto;
      margin-right: 0.5rem;
    }
  }
  & > span {
    margin-top: 0.2rem;
    display: flex;
    align-self: center;
    font-weight: var(--font-weight-bold);

    @include mq(pc) {
      font-size: var(--font-size-md);
    }
    @include mq(sp) {
      font-size: var(--font-size-xs);
    }
  }
}
</style>
